import React, { memo } from 'react';

import { BidExternalStatusType, BidInternalStatusType } from '../../../../../utils/constants';
import { deprecatedCheckCountDown, deprecatedGetBroadcastGap } from '../../../../../utils/helpers';
import { bidssummaryParamType } from '../../../../../types/biddetail';

interface PropsTypes {
  bidssummary: bidssummaryParamType;
}

const HeaderStatistics = (props: PropsTypes) => {
  const { bidssummary } = props;
  const { watchers, results, stats } = bidssummary || {};
  const isStatsLoading = !stats || Object.keys(stats).length === 0;
  const { planholders, broadcasts, postBidViewers, supplimentalSuppliers } = stats|| {};
  const { bidExternalStatusType, bidInternalStatusType, broadcastDate } = results || {};

  const isBroadcasting =
    bidExternalStatusType === BidExternalStatusType.Upcoming &&
    bidInternalStatusType !== BidInternalStatusType.Pending &&
    deprecatedCheckCountDown(broadcastDate) === 'closed' &&
    deprecatedCheckCountDown(deprecatedGetBroadcastGap(broadcastDate)) !== 'closed';
  const isBroadcast = bidExternalStatusType !== BidExternalStatusType.Upcoming;

  const Spinner = () => (
  <small>Loading...</small>
);

  return (
    <div className="row countsWrapper">
      <div className="col text-center">
        <h2>{isStatsLoading? <Spinner /> : isBroadcast ? planholders : '...'}</h2>
        <p>Planholders</p>
      </div>
      <div className="col text-center">
        <h2>{isStatsLoading ? <Spinner /> : isBroadcast ? broadcasts : '...'}</h2>
        <p>{isBroadcasting ? 'Currently broadcasting' : 'Broadcast to'}</p>
      </div>
      <div className="col text-center">
        <h2>{isStatsLoading ? <Spinner /> : supplimentalSuppliers}</h2>
        <p>Supplemental Suppliers</p>
      </div>
      <div className="col text-center">
        <h2>{isStatsLoading ? <Spinner /> : isBroadcast ? (watchers?.total || 0) : '...'}</h2>
        <p>Watchers</p>
      </div>
      <div className="col text-center">
        <h2>
          {isStatsLoading ? <Spinner />  : isBroadcast ? postBidViewers : '...'}</h2>
        <p>Post Bid Viewers</p>
      </div>
    </div>
  );
};

export default memo(HeaderStatistics);
